import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HeaderComponent.css'

const HeaderComponent: React.FC = () => {

    const navigate = useNavigate();
    const handleSearch = () => {
        navigate(`/search`);
      };
    
    const handlePublish = () => {
        navigate(`/publishDomain`);
      };
      
    const handleClick =  () => {
        navigate('/');
      }

    const handleHowItWorks = () => {
      navigate(`/howItWorks`);
    };

    const handleFaqs = () => {
      navigate(`/faqs`);
    };

    const handleContact = () => {
      navigate(`/contact`);
    };

  return (
    <div>
        <div className="header-widget">
            <h3 onClick={handleClick} style={{ cursor: 'pointer'}}>Registry for Planning Domain Models</h3>
        </div>
    <nav className="navbar">
        <button className="nav-button" onClick={handleSearch}>Search by tags</button>
        <button className="nav-button" onClick={handlePublish}>Publish domain model</button>        
        <button className="nav-button" onClick={handleHowItWorks}>How it works?</button>
        <button className="nav-button" onClick={handleFaqs}>FAQs</button>        
        <button className="nav-button" onClick={handleContact}>Contact</button>
    </nav>
    </div>
  );
};

export default HeaderComponent;